'use client';

import { useEffect, useState } from 'react';
import Footer from './Footer';

export default function ConditionalFooter() {
  const [is404Page, setIs404Page] = useState(false);

  useEffect(() => {
    // Check if we're on a 404 page by looking for the data-page="404" attribute
    const check404 = () => {
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        const has404Attribute = mainContent.querySelector('[data-page="404"]');
        setIs404Page(!!has404Attribute);
      }
    };

    // Check after a short delay to ensure DOM is ready
    const timeoutId = setTimeout(check404, 100);
    
    // Also check immediately in case DOM is already ready
    check404();
    
    return () => clearTimeout(timeoutId);
  }, []);

  if (is404Page) {
    return null;
  }

  return <Footer />;
}

